import AiChatbotLeadForm from "@components/AiChatbotLeadForm";
import CreateYourAIChatbotForm from "@components/new-ui/AiChatbot/CreateYourAIChatbotForm";
import { container_classname } from "@components/new-ui/constants";
import CTASection from "@components/new-ui/CTASection";
import FeatureHighlights from "@components/new-ui/FeatureHighlights";
import FeatureInfoCard, { FeatureInfo } from "@components/new-ui/IndustriesSection/FeatureInfoCard";
import NewLayout from "@components/new-ui/Layout";
import StepByStepGuide from "@components/new-ui/StepByStepGuide";
import WhyYourWebsiteNeedThis from "@components/new-ui/WhyYourWebsiteNeedThis";

const featureInfo: FeatureInfo = {
    mainTitle: "How does it help your business?",
    imageUrl: "https://assets.gallabox.com/gb-home/free-tools/ai-chatbot/feature.png",
    featureInfoList: [
        "Available 24*7",
        "Needs less time to learn about your business",
        "Frees up your team's time by answering repetitive questions",
        "Responds quickly",
        "Keeps your prospects/customers engaged",
        "Helps them move to the next stage of conversion.",
    ],
};

const ctaMetricsData = [
    {
        metricValue: "200M+",
        metricType: "Total conversations powered",
    },
    {
        metricValue: "40M+",
        metricType: "Chatbot-driven conversations",
    },
    {
        metricValue: "20K+",
        metricType: "Global active users",
    },
];

const AIChatbot: React.FC = () => {
    return (
        <NewLayout
            title="Try our AI Chat Bot on WhatsApp: Create chat links now!"
            description="Use a FREE WhatsApp Link Generator to make your WhatsApp Business details more accessible to potential and future customers to drive engagement and revenue."
            // canonical="https://gallabox.com/ai-chatbot"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/whatsapp-link-gen/og.png" }}
            noIndex
        >
            <AiChatbotLeadForm />
            <section style={{ backgroundColor: "#EEF4FF" }} className="lg:pt-28 pt-12 lg:pb-20 pb-10">
                <header className={`${container_classname} flex flex-col lg:flex-row lg:py-5 lg:gap-0 gap-8`}>
                    <div className="lg:w-1/2 w-full flex flex-col justify-start lg:gap-0 gap-4">
                        <h6 className="lg:text-base text-xs font-semibold" style={{ color: "#3364FA" }}>
                            WhatsApp AI Chatbot
                        </h6>
                        <h1 className="lg:text-new-h1 text-5xl font-bold lg:mb-6" style={{ fontFamily: "Degular Variable" }}>
                            WhatsApp AI chatbot for your business
                        </h1>
                        <p className="lg:text-xl text-base font-normal lg:w-3/4">
                            Discover how a WhatsApp AI chatbot can learn from your website and interact intelligently with users.
                        </p>
                    </div>
                    <div className="lg:w-1/2 w-full">
                        <CreateYourAIChatbotForm />
                    </div>
                </header>
            </section>
            <WhyYourWebsiteNeedThis />
            <StepByStepGuide />
            <FeatureHighlights />
            <FeatureInfoCard {...featureInfo} />
            <CTASection
                title="Impressed with our free WhatsApp AI chatbot generator?"
                description={
                    <span>
                        Level up and create AI-based chatbots for all your marketing and sales needs.
                        <br />
                        <br />
                        Start your 7-day free trial now!
                    </span>
                }
                metricsData={ctaMetricsData}
            />
        </NewLayout>
    );
};

export default AIChatbot;
